import { Box, Button, FormControl, Grid, Typography } from "@mui/material";
import FullScreenLoadingIndicator from "../../UI/FullScreenLoadingIndicator";
import AutoCompleteUsers from "../../UI/AutoCompleteUsers";
import { useDispatch, useSelector } from "react-redux";
import AutoCompleteICAT from "../../UI/AutoCompleteICAT";
import { AdminAction } from "../../../store/Admin/Admin-slice";
import useHttp from "../../../Hooks/use-http";
import { APIURL } from "../../Util/Util";
import { useMemo, useState } from "react";
import InfoTable from "../../UI/Table";
import ErrorBox from "../../Util/ErrorBox";
import MessageBox from "../../Util/MessageBox";
import ConfirmationBox from "../../Util/ConfirmationBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddEditAssignICATModal from "./AddEditAssignICATModal";

let inputTimeOut;
let inputTimeOutiCAT;

const AssignICAT = () => {
  const [errorMsg, setErrorMsg] = useState("");
  const [ErrorState, setErrorState] = useState(false);

  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [resultMessage, setResultMessage] = useState("");
  const [openConfirmDeleteMessage, setOpenConfirmDeleteMessage] =
    useState(false);

  const deleteAssignICATState = useSelector(
    (state) => state.adminState.deleteAssignICATState
  );
  const dispatch = useDispatch();
  const { sendRequest: fetcUserList, isLoading: isUserListLoading } = useHttp();
  const { sendRequest: fetchICATOptions, isLoading: isLoadingICATOptions } =
    useHttp();
  const { sendRequest: fetchUserAssignICAT, isLoading: isLoadingAssignICAT } =
    useHttp();
  const {
    sendRequest: deleteMultiAssignICAT,
    isLoading: isLoadingDeleteAssignICAT,
  } = useHttp();
  const {
    sendRequest: fetchUserOrgOptions,
    isLoading: isLoadingUserOrgOptions,
  } = useHttp();

  const accessToken = useSelector(
    (state) => state.authenticationState.accessToken
  );

  const headers = useMemo(
    () => ({
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    }),
    [accessToken]
  );

  const handleUserInputChange = (newValue, name, reason) => {
    clearTimeout(inputTimeOut);
    inputTimeOut = setTimeout(() => {
      if (newValue.length > 2 && reason === "input") {
        console.log("queried " + newValue);
        fetcUserList(
          {
            url: `${APIURL}admin/usersList/?filterOn=${newValue}`,
            headers,
          },
          (data) => {
            const usersList = data.USERS_LIST.sort();
            dispatch(
              AdminAction.setDeleteAssignICATState({
                userOptions: usersList,
              })
            );
          },
          (error) => {
            console.log("ERROR: ", error);
            setErrorMsg(`ERROR: Unable to retrieve name, ${error}`);
            setErrorState(true);
          }
        );
      }
    }, 500);
  };

  const fetchOrgOptionsForUser = (userid) => {
    return new Promise((resolve, reject) => {
      fetchUserOrgOptions(
        { url: `${APIURL}admin/userOrgList?filterOn=${userid}`, headers },
        (data) => {
          const orgOptions = data?.USER_ORG_LIST?.map((org) => org.user_org_c);
          resolve(orgOptions);
        },
        (error) => {
          setErrorMsg(
            `ERROR: Unable to retrieve User Org Options, please try refresh the page. Error: ${error}`
          );
          setErrorState(true);
          reject(error);
        }
      );
    });
  };

  const handleiCATInputChange = (newValue, name, reason) => {
    clearTimeout(inputTimeOutiCAT);

    inputTimeOut = setTimeout(() => {
      if (newValue?.length > 2 && reason === "input") {
        console.log("queried " + newValue);
        fetchICATOptions(
          {
            url: `${APIURL}admin/iCATList/?filterOn=${newValue}`,
            headers,
          },
          (data) => {
            const iCATList = data.ICAT_LIST.sort();

            const transformedSelections = iCATList.map((item) => ({
              id: item.icat_id,
              label: item.icat,
              ...item,
            }));

            dispatch(
              AdminAction.setDeleteAssignICATState({
                iCATOptions: transformedSelections,
              })
            );
          },
          (error) => {
            console.log("ERROR: ", error);
            setErrorMsg(`ERROR: Unable to retrieve iCAT, ${error}`);
            setErrorState(true);
          }
        );
      }
    }, 500);
  };

  const handleInputChange = (type) => (event, newValue) => {
    if (type === "selectedUser" && newValue) {
      dispatch(
        AdminAction.setDeleteAssignICATState({
          error: { ...deleteAssignICATState?.error, isUserError: false },
        })
      );
    }
    dispatch(AdminAction.setDeleteAssignICATState({ [type]: newValue }));
  };

  const handleDeleteConfirm = () => {
    deleteMultiAssignICAT(
      {
        url: `${APIURL}admin/deleteMultiAssignICAT`,
        headers,
        method: "POST",
        body: {
          ids: deleteAssignICATState?.selectedRows,
        },
      },
      (data) => {
        setResultMessage(data.Success);
        setOpenMessageBox(true);
        // dispatch(AdminAction.resetDeleteAssignICAT());
        getAssignICATTableData();
      },
      (error) => {
        console.log(error);
        setErrorMsg(
          `ERROR: Unable to delete Assign ICATs, please re-open this popup and try again. ${error}`
        );
        setErrorState(true);
      }
    );
    console.log("selectedRows:", deleteAssignICATState?.selectedRows);
  };

  const handleDeleteClicked = () => {
    if (deleteAssignICATState?.selectedRows?.length === 0) {
      setErrorMsg("Please select at least one row to delete.");
      setErrorState(true);
      return;
    } else if (deleteAssignICATState?.selectedRows?.length > 100) {
      setErrorMsg(
        "You cannot select more than 100 rows for deletion. Please reduce your selection."
      );
      setErrorState(true);
      return;
    }
    setOpenConfirmDeleteMessage(true);
  };
  // const handleCancelClicked = () => {
  //   dispatch(AdminAction.resetDeleteAssignICAT());
  //   dispatch(AdminAction.setOpenDeleteAssignICAT(false));
  // };

  const getAssignICATTableData = () => {
    if (!deleteAssignICATState?.selectedUser && !deleteAssignICATState?.selectedICAT) {
      // dispatch(
      //   AdminAction.setDeleteAssignICATState({
      //     error: { ...deleteAssignICATState?.error, isUserError: true },
      //   })
      // );
      return;
    }
    fetchUserAssignICAT(
      {
        method: "POST",
        url: `${APIURL}admin/getMultiUserAssignICAT`,
        headers,
        body: {
          user: deleteAssignICATState?.selectedUser?.ntuser,
          icat: deleteAssignICATState?.selectedICAT?.icat_id,
        },
      },
      (data) => {
        const userAssignICATs = data.MTL_RESP_LIST.sort();

        const transformedSelections = userAssignICATs.map((item) => ({
          id: item.icat_id,
          label: item.icat,
          ...item,
        }));

        dispatch(
          AdminAction.setDeleteAssignICATState({
            userAssignICATList: transformedSelections,
          })
        );
      },
      (error) => {
        console.log("ERROR: ", error);
        setErrorMsg(`ERROR: Unable to retrieve iCAT, ${error}`);
        setErrorState(true);
      }
    );
  };

  const messageBoxHandler = () => {
    setOpenMessageBox(false);
    dispatch(AdminAction.setOpenDeleteAssignICAT(false));
  };

  const handleDeleteYes = () => {
    setOpenConfirmDeleteMessage(false);
    handleDeleteConfirm();
  };

  const columnsSettings = [
    { field: "username", headerName: "User", type: "text", flex: 0.7 },
    { field: "org", headerName: "Org", type: "text", flex: 0.3 },
    { field: "icat", headerName: "ICAT", type: "text", flex: 0.5 },
    { field: "oracleID", headerName: "Oracle ID", type: "text", flex: 0.4 },
    { field: "legacy", headerName: "Legacy", type: "text", flex: 0.4 },
    // { field: "telnet", headerName: "Telnet", type: "text", flex: 0.4 },
  ];

  const transformRowForEdit = (row) => {
    return {
      id: row.id,
      username: row.username,
      iCATOptions: row.icat
        ? [
            {
              id: row.oracleID,
              label: row.icat,
              icat: row.icat,
              icat_id: row.oracleID,
              lcat: row.legacy,
            },
          ]
        : [],
      org: row.org,
      iCAT: row.icat
        ? {
            id: row.oracleID,
            label: row.icat,
            icat: row.icat,
            icat_id: row.oracleID,
            lcat: row.legacy,
          }
        : "",
      oracleID: row.oracleID,
      legacy: row.legacy,
      telnet: row.telnet,
      remove: [],
      error: {},
      userOptions: row.ntuser
        ? [
            {
              useremail: row.useremail || "",
              username: row.username,
              userid: row.ntuser,
              ntuser: row.ntuser,
              user_org_c: row.org,
              userstatus: "A",
            },
          ]
        : [],
      user: row.ntuser
        ? {
            useremail: row.useremail || "",
            username: row.username,
            userid: row.ntuser,
            ntuser: row.ntuser,
            user_org_c: row.org,
            userstatus: "A",
          }
        : "",
      userid: row.ntuser,
      useremail: row.useremail || "",
      orgOptions: row.org ? [row.org] : [],
    };
  };

  const handleOpenAssignICAT = () => {
    dispatch(AdminAction.setOpenAssignICAT(true));
  };

  const handleEditClicked = async () => {
    // Get selected rows' data from userAssignICATList
    const selectedRows = deleteAssignICATState.userAssignICATList.filter(
      (row) => deleteAssignICATState.selectedRows.includes(row.id)
    );
    if (!selectedRows.length) return;

    const ntuser = selectedRows[0].ntuser;
    const orgOptions = await fetchOrgOptionsForUser(ntuser);

    const selectedRowsData = selectedRows.map((row) => ({
      ...transformRowForEdit(row),
      orgOptions, // set all orgs for this user
    }));

    console.log("selectedRowsData--", selectedRowsData);
    dispatch(AdminAction.setAssignICATEdit(true));
    dispatch(AdminAction.addAssignICAT(selectedRowsData));
    dispatch(AdminAction.setOpenAssignICAT(true));
  };

  const customToolBar = () => (
    <>
      <Typography fontSize={14} mr={2}>
        {"Please search ICAT by user or ICAT "}
      </Typography>
      <Button
        disabled={!deleteAssignICATState?.selectedRows?.length}
        onClick={handleEditClicked}
        startIcon={<EditIcon />}
      >
        {"Edit"}
      </Button>
      <Button
        startIcon={<DeleteIcon />}
        disabled={!deleteAssignICATState?.selectedRows?.length}
        onClick={handleDeleteClicked}
      >
        Delete
      </Button>
    </>
  );

  return (
    <Box
      sx={{
        mx: "6%",
        height: "calc(100vh - 200px)",
      }}
    >
      <ConfirmationBox
        open={openConfirmDeleteMessage}
        handleYes={handleDeleteYes}
        handleNo={() => setOpenConfirmDeleteMessage(false)}
        message={`Delete ${deleteAssignICATState?.selectedRows?.length} User Assign ICATs?`}
      />
      <AddEditAssignICATModal getAssignICATTableData={getAssignICATTableData} />
      <FullScreenLoadingIndicator
        loading={
          isLoadingAssignICAT ||
          isLoadingDeleteAssignICAT ||
          isLoadingUserOrgOptions
        }
      />

      <MessageBox
        open={openMessageBox}
        message={resultMessage}
        messageBoxHandler={messageBoxHandler}
      />
      <ErrorBox
        msg={errorMsg}
        setErrorState={setErrorState}
        ErrorState={ErrorState}
      />
      <Grid
        mb={2}
        mt={1}
        container
        direction="row"
        justifyContent="start"
        alignItems="flex-start"
        rowSpacing={2}
        columnSpacing={1}
        wrap={"wrap"}
      >
        <Grid item xl={5} lg={5} md={5} sm={5} xs={12}>
          <FormControl fullWidth>
            <AutoCompleteUsers
              value={deleteAssignICATState?.selectedUser}
              label="User"
              error={deleteAssignICATState?.error?.isUserError}
              // required={true}
              onChange={handleInputChange("selectedUser")}
              handleUserInputChange={handleUserInputChange}
              options={deleteAssignICATState?.userOptions || []}
              isLoading={isUserListLoading}
              name={"user"}
              helperText={"*Insert more than 3 characters to search"}
            />
          </FormControl>
        </Grid>

        <Grid item xl={5} lg={5} md={5} sm={5} xs={12}>
          <AutoCompleteICAT
            required={false}
            value={deleteAssignICATState?.selectedICAT}
            label="ICAT"
            onChange={handleInputChange("selectedICAT")}
            onInputChange={handleiCATInputChange}
            options={deleteAssignICATState.iCATOptions || []}
            error={deleteAssignICATState.error?.isICATError}
            isLoading={isLoadingICATOptions}
            name={"iCAT"}
            helperText={"*Insert more than 3 characters to search"}
          />
        </Grid>

        <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
          <Box sx={{ display: "flex" }}>
            <Button fullWidth onClick={getAssignICATTableData}>
              Search
            </Button>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Button fullWidth onClick={handleOpenAssignICAT}>
              Add Assign ICAT
            </Button>
          </Box>
        </Grid>
      </Grid>

      <InfoTable
        columnsSettings={columnsSettings}
        rows={deleteAssignICATState?.userAssignICATList}
        checkboxSelection={true}
        customToolBar={customToolBar}
        rowsPerPageOptions={[15, 25, 50]}
        autoTableHeight={false}
        height={540}
        maxtableHeight={1}
        noRowsSettings={true}
        pageSize={25}
        ExtraProps={{
          onSelectionModelChange: (newSelection) => {
            dispatch(
              AdminAction.setDeleteAssignICATState({
                selectedRows: newSelection,
              })
            );
          },
          selectionModel: deleteAssignICATState?.selectedRows || [],
        }}
      />
    </Box>
  );
};

export default AssignICAT;
